/* unplugin-vue-components disabled */import { render } from "./UserZfb.vue?vue&type=template&id=f58a7ffc&scoped=true"
import script from "./UserZfb.vue?vue&type=script&lang=js"
export * from "./UserZfb.vue?vue&type=script&lang=js"

import "./UserZfb.vue?vue&type=style&index=0&id=f58a7ffc&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f58a7ffc"]])

export default __exports__